import { Component, Inject, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Classifier } from '@nano/common/classifier';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { PaymentConditions } from '@nano/payment/payment';

@Component({
  selector: 'app-instruction-identification',
  templateUrl: './instruction-identification.component.html',
  standalone: false
})
export class InstructionIdentificationComponent {
  @Input() form: FormGroup;
  @Input() instructionCodes$: Observable<Classifier[]>;
  @Input() isInstructionIdentificationEnabled: boolean;
  @Input() instructionIdentificationControl: AbstractControl;
  @Input() paymentConditions: PaymentConditions;

  userMustProvideInstructionId: boolean;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
